import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
// import { Search } from 'react-bootstrap-table2-toolkit';
// import { useDebouncedCallback } from 'use-debounce';
import { getContacts } from '../../recoil/selectors/getContacts';
// import { contactSearch } from '../../recoil/atoms/contactSearch';
// const { SearchBar } = Search;
// const columns = [
//   {
//     dataField: 'crmname',
//     text: 'CRM',
//   },
//   {
//     dataField: 'company',
//     text: 'Company',
//   },
//   {
//     dataField: 'name',
//     text: 'Name',
//   },
//   {
//     dataField: 'phones',
//     text: 'Phone(s)',
//   },
//   {
//     dataField: 'emails',
//     text: 'Email(s)',
//   },
//   {
//     dataField: 'externalid',
//     text: 'External ID',
//   },
// ];

export function ContactsPage() {
  // state for day/week/month grouping
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // const [searchValue, setSearchValue] = useRecoilState(contactSearch);
  const contacts = useRecoilValue(
    getContacts({
      page,
      pageSize,
    })
  );
  let editable = [];
  if (contacts?.data) {
    editable = contacts.data?.contacts.map((o) => ({
      ...o,
    }));
  }
  const handleTableChange = (type, { page: _page, sizePerPage }) => {
    // if(_page + sizePerPage  >= contacts.data.total){
    //   const size = contacts.data.total - sizePerPage
    //   setPage(size)
    // }
    setPageSize(sizePerPage);
    // go back to first page if page size is not changed
    setPage(sizePerPage === pageSize ? _page : 1);
  };
  // const { callback: debouncedCallback } = useDebouncedCallback(
  //   (value) => {
  //     setSearchValue(value);
  //   },
  //   // delay in ms
  //   1000
  // );
  const RemotePagination = ({
    data,
    page,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      'react-bootstrap-table-next' 'react-bootstrap-table2-paginator';
      {/* <BootstrapTable
        remote
        search={{
          defaultSearch: searchValue,
        }}
        key="externalid"
        keyField="externalid"
        data={data}
        columns={columns}
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
          withFirstAndLast: false,
        })}
        onTableChange={onTableChange}
      /> */}
    </div>
  );
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <div
        style={{
          maxWidth: '100%',
          backgroundColor: '#FFFFFF',
        }}
      >
        <Box component="div" p={3}>
          <Typography component="div">
            <h3> Search : </h3>
            {/* react-bootstrap-table2-toolkit */}
            {/* <SearchBar
              searchText={searchValue}
              onSearch={(e) => debouncedCallback(e)}
            /> */}
            <RemotePagination
              data={editable}
              key="externalid"
              keyField="externalid"
              page={page}
              sizePerPage={pageSize}
              totalSize={contacts.data.total}
              onTableChange={handleTableChange}
            />
          </Typography>
        </Box>
      </div>
    </React.Suspense>
  );
}
